// extracted by mini-css-extract-plugin
module.exports =  {"pill":"KpDJjrf6","border":"Gx3FWewz","centered":"R1QhsB4t"};